module.exports = __webpack_public_path__ + "images/logo-assinatura-azul.png?a9c2fdd2ae14073ec4f5a26fefa5d5dc";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/assets/images/icons/logo-assinatura-azul.png
// module id = 996
// module chunks = 0